import React from "react"
import Cookies from "js-cookie"
import { Button, Typography } from "@mui/material"
import { ADVISOR_APP_HOST } from "../constants"
import { useLocation } from "react-router-dom"

export interface CapserCookie {
  userId: number,
  executorName: string,
  estateId: number,
  estateName: string,
}

export function clearCasperModeAndRedirect(): void {
  const casperCookie = getCasperInfo()
  Cookies.remove("acting_as", { domain: "localhost", path: "/" })
  Cookies.remove("acting_as", { domain: "weareatticus.com", path: "/" })
  window.location.href = ADVISOR_APP_HOST + "/app/estates/" + casperCookie?.estateId
}

export function getCasperInfo(): CapserCookie | undefined {
  const casperCookieString = Cookies.get("acting_as")
  if (!casperCookieString) {
    return undefined // No content.  spooky?
  }

  let casperCookie: CapserCookie = {
    userId: -1,
    executorName: "unknown",
    estateId: -1,
    estateName: "unknown",
  }
  if (Number.isInteger(casperCookieString)) {
    casperCookie.userId = parseInt(casperCookieString)
  } else {
    try {
      casperCookie = JSON.parse(casperCookieString)
    } catch (e) {
      console.log("unable to parse casper cookie " + (e as any)?.message)
      return undefined
    }
  }

  return casperCookie
}

export function CasperBanner(props: { isLoginBoxBanner?: boolean }): JSX.Element {
  // There is a banner that already shows up in the login box for the /auth page
  const location = useLocation()
  if (!props.isLoginBoxBanner && location.pathname == "/auth") {
    return <></>
  }

  const casperCookie = getCasperInfo()
  if (!casperCookie) {
    return <></>
  }

  return <Typography variant="body2" component="div" style={{
    display: "flex",
    backgroundColor: "#ffffb7",
    maxWidth: "50rem",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "0.5rem",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.75rem",
    borderRadius: "1rem",
    border: "1px lightgray solid"
  }}>
    <div style={{ fontSize: "2.5rem" }}>
      👻
    </div>
    <div>
      <b>Reminder:</b>
      &nbsp;
      <i>
        You are currently using Casper Mode to impersonate {casperCookie.executorName}&nbsp;
        in the {casperCookie.executorName}&nbsp; account.&nbsp;
        {props.isLoginBoxBanner && <>Please use your <b>Atticus Advisor credentials to turn into Casper.</b></>}&nbsp;
        Use the button to end Casper Mode.
      </i>
    </div>
    <div>
      <Button
        onClick={clearCasperModeAndRedirect}
        color="warning"
        style={{
          backgroundColor: "#fff192",
          whiteSpace: "nowrap",
          border: "none",
          borderRadius: "1rem",
          padding: "0.5rem",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          boxShadow: "lightgray 1px 1px 3px"
        }}>
        <Typography variant="body2" component="div">
          shoo Casper, shoo!
        </Typography>
      </Button>
    </div>
  </Typography>
}